import {
  Mesh,
  MeshBasicMaterial,
  PlaneGeometry,
} from 'three';

const geometry = new PlaneGeometry(1, 1);
const decalColors = {
  impact: 0x0c1018,
  blood: 0x3b0610,
  scorch: 0x15100c,
};

let decalState = null;

export function initDecals(world, options = {}) {
  const capacity = options.capacity ?? 64;
  decalState = {
    world,
    capacity,
    cursor: 0,
    decals: Array.from({ length: capacity }, createDecal),
  };
  for (const decal of decalState.decals) world.particleRoot.add(decal.mesh);
  return decalState;
}

export function spawnDecal(position, normal = null, type = 'impact', options = {}) {
  const state = decalState;
  if (!state) return null;
  const decal = state.decals[state.cursor];
  state.cursor = (state.cursor + 1) % state.capacity;

  decal.age = 0;
  decal.ttl = options.ttl ?? 30;
  decal.fade = options.fade ?? 5;
  decal.mesh.visible = true;
  decal.mesh.position.set(position.x, options.y ?? 0.035, position.z);
  decal.mesh.rotation.x = -Math.PI / 2;
  decal.mesh.rotation.z = Math.random() * Math.PI * 2;
  decal.mesh.scale.setScalar(options.size ?? 0.42);
  decal.mesh.material.color.setHex(options.color ?? decalColors[type] ?? decalColors.impact);
  decal.mesh.material.opacity = options.opacity ?? 0.52;
  decal.baseOpacity = decal.mesh.material.opacity;
  return decal;
}

export function updateDecals(dt) {
  const state = decalState;
  if (!state) return;
  for (const decal of state.decals) {
    if (!decal.mesh.visible) continue;
    decal.age += dt;
    const fadeStart = Math.max(0, decal.ttl - decal.fade);
    if (decal.age > fadeStart) {
      decal.mesh.material.opacity = decal.baseOpacity * Math.max(0, 1 - (decal.age - fadeStart) / decal.fade);
    }
    if (decal.age >= decal.ttl) decal.mesh.visible = false;
  }
}

function createDecal() {
  const mesh = new Mesh(
    geometry,
    new MeshBasicMaterial({
      color: decalColors.impact,
      transparent: true,
      opacity: 0.52,
      depthWrite: false,
      polygonOffset: true,
      polygonOffsetFactor: -1,
    }),
  );
  mesh.visible = false;
  return { mesh, age: 0, ttl: 30, fade: 5, baseOpacity: 0.52 };
}
